export const getResizeObserverObject = () => {
    const globalObject = typeof globalThis !== 'undefined' ? globalThis : window;
    return globalObject.ResizeObserver;
};
